module.exports = __webpack_public_path__ + "img/Egypt, Arab Rep..1c162440.gif";